import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const ARTIST_CARD_HEIGHT = 53;
const ACTION_WIDTH = spacing.xl - spacing.xxs;

export const styles = createThemedStyles(theme => ({
  card: {
    height: ARTIST_CARD_HEIGHT,
    paddingVertical: 0,
    paddingHorizontal: 0,
    overflow: 'hidden',
    borderRadius: ARTIST_CARD_HEIGHT / 2,
  },
  container: {
    flexDirection: 'row',
    height: '100%',
    overflow: 'hidden',
  },
  imageContainer: {
    height: '100%',
    aspectRatio: 1,
    padding: spacing.xxs,
    justifyContent: 'center',
    alignItems: 'center',
  },
  imageWrapper: {
    height: '100%',
    width: '100%',
    borderRadius: ARTIST_CARD_HEIGHT / 2,
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    paddingLeft: spacing.xxs,
    paddingRight: spacing.xs,
    flexDirection: 'row',
    alignItems: 'center',
  },
  action: {
    width: ACTION_WIDTH,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
